import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const applyReceipt = (receipt_id, receipt_amount, applied_amount,contract_id,invoiceId) => {
  return axios.post(API + "receipts/apply/receipts/", {
    receipt_id,
    receipt_amount,
    applied_amount,
    contract_id,
    invoiceId
  },{headers: authHeader(),});
};
const ApplyReceiptService = {
    applyReceipt,
  };
  export default ApplyReceiptService;